/**
 * ZTYLIST — Core Theme JS
 * assets/theme.js
 */
(function() {
  'use strict';

  window.ZT = window.ZT || {};

  // ── UTILITY: debounce ──────────────────────────────────────
  ZT.debounce = function(fn, wait) {
    var timer;
    return function() {
      var args = arguments;
      var self = this;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(self, args); }, wait);
    };
  };

  // ── UTILITY: format money ──────────────────────────────────
  ZT.formatMoney = function(cents, currency) {
    currency = currency || (window.ZT.config && window.ZT.config.currency) || 'USD';
    var symbols = { GBP: '£', USD: '$', EUR: '€', CAD: 'CA$', AUD: 'A$' };
    var sym = symbols[currency] || currency + ' ';
    return sym + (cents / 100).toFixed(2);
  };

  // ── QUICK ADD ──────────────────────────────────────────────
  // Card buttons are real forms/links (they work even before this script
  // loads); once JS is ready we upgrade them to AJAX + the quick-view popup.

  // Multiple variants → real link, upgraded to the quick-view popup.
  document.addEventListener('click', function(e) {
    var qvBtn = e.target.closest('.product-card__add-btn[data-quick-view]');
    if (!qvBtn) return;
    var handle = qvBtn.dataset.productHandle;
    if (handle && document.getElementById('QuickViewModal')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('zt:quickview:open', { detail: { handle: handle } }));
    }
    // No quick-view on this page → let the link navigate to the product page.
  });

  // Single variant → real form, upgraded to an AJAX add with instant drawer feedback.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('product-card__add-form')) return;
    e.preventDefault();

    var addBtn = form.querySelector('.product-card__add-btn');
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId || (addBtn && addBtn.disabled)) return;

    if (addBtn) {
      addBtn.textContent = 'Adding…';
      addBtn.disabled = true;
    }

    // Instant feedback: open the drawer now with a loading row.
    document.dispatchEvent(new CustomEvent('zt:cart:open', { detail: { loading: true } }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) throw data;
        return data;
      });
    })
    .then(function() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.dispatchEvent(new CustomEvent('zt:cart:updated', { detail: { cart: cart } }));
      if (addBtn) {
        addBtn.textContent = 'Added!';
        addBtn.style.background = 'var(--clr-green)';
        setTimeout(function() {
          addBtn.textContent = 'Add to Cart';
          addBtn.style.background = '';
          addBtn.disabled = false;
        }, 1500);
      }
    })
    .catch(function(err) {
      console.error('Quick add error:', err);
      var msg = (err && err.description) ? err.description : 'Could not add to cart - please try again.';
      if (window.ZT && window.ZT.toast) window.ZT.toast(msg, 'error');
      document.dispatchEvent(new CustomEvent('zt:cart:error', { detail: { message: msg } }));
      if (addBtn) {
        addBtn.textContent = 'Error';
        addBtn.style.background = 'var(--clr-error)';
        setTimeout(function() {
          addBtn.textContent = 'Add to Cart';
          addBtn.style.background = '';
          addBtn.disabled = false;
        }, 2000);
      }
    });
  });

  // ── HEADER SCROLL BEHAVIOR ────────────────────────────────
  // Owned by sections/header.liquid (sticky-on-scroll-up + .scrolled).
  // Kept here intentionally empty to avoid a second scroll listener.

  // ── CUSTOM EVENTS ─────────────────────────────────────────
  // zt:cart:open  — open cart drawer
  // zt:search:open — open search overlay
  // zt:search:close — close search overlay
  // zt:content:updated — re-run animations on new content

  // ── ACCESSIBLE FOCUS TRAP (for drawers/modals) ─────────────
  ZT.trapFocus = function(element) {
    var focusable = element.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    element.addEventListener('keydown', function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    });
  };

  // ── PRODUCT IMAGE PRELOAD ─────────────────────────────────
  ZT.preloadImage = function(src) {
    var img = new Image();
    img.src = src;
  };

  // Preload second product image on card hover
  document.querySelectorAll('.product-card').forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      var altImg = card.querySelector('.product-card__img--alt');
      if (altImg && altImg.src) ZT.preloadImage(altImg.src);
    }, { once: true });
  });

  // ── SECTION REFRESH (for Shopify theme editor) ─────────────
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      document.dispatchEvent(new CustomEvent('zt:content:updated'));
    });
  }

})();